/**
 * Lean-angle presentation knobs.
 */

/**
 * Unit: seconds. Window for the SUSTAINED peak-lean statistic: the headline
 * "max lean" is the maximum rolling median of |lean| over this window, not
 * the instantaneous sample max. A 1-2 sample excursion (sensor noise, a
 * GPS-heading blip at a kerb strike) cannot claim the headline — only lean
 * the rider actually held does. Reference behavior: on session-143033 the
 * corrected lean peaks at 59.9° instantaneous vs 58.1° sustained (1 s), and
 * consumer apps present the same corner as ~52° with heavier smoothing.
 * Raise for a calmer, more conservative headline; lower toward 0 to
 * approach the instantaneous max. The full lean SERIES is untouched —
 * charts still show every sample. Default: 1
 */
export const LEAN_PEAK_SUSTAIN_WINDOW_S = 1
